/**
 * Export API service
 */
import { useMutation } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { ApiSuccess } from '../lib/api';

export type ExportFormat = 'epub' | 'docx';

export function useExportBook(bookId: string) {
  return useMutation({
    mutationFn: async (format: ExportFormat) => {
      const res = await api.get<ApiSuccess<{ downloadUrl: string }>>(
        `/books/${bookId}/export?format=${format}`,
      );
      return res.data.data;
    },
  });
}
